// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cor8","delete":"styles_delete__14sJE","update":"styles_update__3_e-o","add":"styles_add__2gI00"};